import React from 'react'
import FormControlCustom from './FormControlCustom'
import FormGroup from './form-group/FormGroup'
import i18n from "i18next";
import {ColFormModel, FormGroupCustomPropsModel} from "./models/FormModule";

const FormGroupCustom = ({
                             isSubmit,
                             errors,
                             structure,
                             onBlur,
                             dataForm,
                             ...rest
                         }: FormGroupCustomPropsModel) => {

    const {t}: any = i18n;

    const colSize = structure?.col ? (Object.keys(structure?.col) as Array<keyof ColFormModel>).map((ele) => `col-${ele}-${structure.col[ele]}`).join(' ') : ''

    return (
        <div className={colSize}>
            <FormGroup
                display={structure?.display}
                label={{label: structure?.label || ''}}
                error={{
                    isVisible: isSubmit && !!errors && !!errors[structure?.name],
                    message: errors ? t(
                        'errors.' + errors[structure?.name]?.code,
                        errors[structure.name]?.params
                    ) : '',
                }}
            >
                <FormControlCustom
                    isSubmit={isSubmit}
                    errors={errors}
                    structure={structure}
                    onBlur={onBlur}
                    dataForm={dataForm}
                    {...rest}
                />
            </FormGroup>
        </div>

    )
}

export default FormGroupCustom
